"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const security_error_1 = require("./security-error");
class TwingSandboxSecurityNotAllowedTagError extends security_error_1.TwingSandboxSecurityError {
    constructor(message, functionName, lineno = -1, filename = null) {
        super(message, lineno, filename);
        this.tagName = functionName;
        this.name = 'TwingSandboxSecurityNotAllowedTagError';
    }
    getTagName() {
        return this.tagName;
    }
}
exports.TwingSandboxSecurityNotAllowedTagError = TwingSandboxSecurityNotAllowedTagError;
